<template>
  <div class="lang-switch">
    <ul class="lang-list">
      <li v-for="locale in locales" :key="locale.code">
        <a
          class="text-medium"
          :class="{ active: locale.code === currentLocale }"
          :href="`${localePath('index', locale.code)}`"
        >
          <span>{{ locale.code.toUpperCase() }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
const { locale, locales } = useI18n()
const currentLocale = computed(() => locale.value)
</script>

<script>
export default {
  name: 'FooterLangSwitch',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
